module.exports = __webpack_public_path__ + "static/img/chain-interval.f7b5e8ae.png";